const addingNewRoomKey = 'entering-new-room';
export default addingNewRoomKey;
